import Barba from 'barba.js'
import NavbarManager from './NavbarManager'
import CarouselManager from './CarouselManager'
import AnimationManager from './AnimationManager'
import ContactsManager from './ContactsManager'
import ModalManager from './ModalManager'
import ScrollViewer from './ScrollViewer'
import ScrollAnimations from './ScrollAnimations'
import IubendaManager from './IubendaManager'

const RouterManager = (() => {
  const initTransition = function initTransition() {
    let destination = null
    Barba.Dispatcher.on('linkClicked', (el) => {
      destination = el.dataset.destination
    })

    const MainTransition = Barba.BaseTransition.extend({
      start: function start() {
        Promise
        .all([this.newContainerLoading, this.exit()])
        .then(this.finish.bind(this))
      },

      exit: function fadeOut() {
        const deferred = Barba.Utils.deferred()

        AnimationManager.enterTransition(() => {
          deferred.resolve()
        })

        return deferred.promise
      },

      finish: function finish() {
        window.scroll(0, 0)
        document.body.scrollTop = 0

        this.done()

        AnimationManager.exitTransition()
      },
    })

    Barba.Pjax.getTransition = () => MainTransition
  }

  const reInit = () => {
    NavbarManager.init()
    CarouselManager.init()
    ModalManager.init()
    ScrollViewer.init()
    AnimationManager.init()
    ContactsManager.init()
    IubendaManager.init()

    if (window.matchMedia('(min-width: 1024px)').matches) {
      ScrollAnimations.hideDOM()
      ScrollAnimations.init()
    }

    const form = document.querySelector('.wpcf7-form.init')
    console.log('running', form)
    if (form && typeof wpcf7 !== 'undefined') {
      wpcf7.init(form)
    }
  }

  const initRouter = () => {
    Barba.Pjax.Dom.containerClass = 'l-site-container'
    Barba.Pjax.Dom.wrapperId = 'page-wrap'
    Barba.Pjax.ignoreClassLink = 'no-barba'

    Barba.Pjax.start()
    Barba.Prefetch.init()

    initTransition()

    Barba.Dispatcher.on('transitionCompleted', () => {
      reInit()
    })
  }

  const init = () => {
    initRouter()
  }

  return {
    init,
  }
})()

export default RouterManager
